import { gql } from '@apollo/client';
import { OrderInfoShared } from '../fragments';

export default gql`
  query order($id: ID) {
    order(id: $id) {
      ...OrderInfoShared
      awaitingSubscriptionAcknowledgment
    }
  }
  ${OrderInfoShared}
`;
